import React, { useCallback, useEffect } from 'react';

import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/createStore';
import { customerFavoriteList, customerFavoriteSave } from '../../../store/modules/auth/actions';
import { checkoutActionTypes } from '../../../store/modules/checkout/types';
import { ProductData } from '../../../store/modules/product/types';
import { useCheckoutFunction } from '../../../hooks/useCheckoutFunctions';

import {
  Container,
  ContainerMyFavorite,
  MyFavoriteTitle,
  ProductsList,
  ProductRow,
  ContainerImagem,
  ProductImagem,
  ContainerDetal,
  ProductTitle,
  ProductCategory,
  ContainerActions,
  ButtonRemove,
  ButtonAdd,
  Root,
  AlertMessageContainer
} from './styles';
import { useToast } from '../../../hooks/toast';
import { useTranslation } from '../../../hooks/useTranslation';

const Favorite: React.FC = () => {
  const { handleCheckoutActions } = useCheckoutFunction();
  const { user, isSignedIn, loading } = useSelector((state: StoreState) => state.auth);
  const { multistoreSelected } = useSelector((state: StoreState) => state.parameter);
  const dispatch = useDispatch();
  const { onSetMessage } = useToast();
  const { onTranslation: t } = useTranslation();

  useEffect(() => {
    if (user.data.id)
      dispatch(customerFavoriteList());
  }, [dispatch, user.data.id, multistoreSelected]);

  const handleFavorite = useCallback(
    async (product: ProductData) => {
      //konsole.log('handleFavorite: ', product);
      if (!isSignedIn) {
        onSetMessage({ type: 'error', description: t('main.messages_toast.login') });
        return;
      }
      if (user && user.data.id && product.product_id) {
        dispatch(customerFavoriteSave(user.data.id?.toString(), product.product_id?.toString()));
      }
    },
    [user, dispatch, isSignedIn, onSetMessage, t],
  );

  return (
    <Root>
      <Container>
        <ContainerMyFavorite>
          <MyFavoriteTitle>
            {!loading && (user.favorite?.length === 0 || !user.favorite) ? (
              <>
                <span>{t('main.favorites.title_01')}</span>
                <p>{t('main.favorites.subtitle')}</p>
              </>
            ) : (
              <span>{t('main.favorites.title_01')}</span>
            )}
          </MyFavoriteTitle>
          <ProductsList>
            {user && user.favorite &&
              user.favorite.map(product => {
                return (
                <ProductRow key={product.id}>
                  <section>
                    <ContainerImagem>
                      <ProductImagem>
                        <img
                          src={product.image_url}
                          alt={product.short_description}
                        />
                      </ProductImagem>
                    </ContainerImagem>
                    <ContainerDetal>
                      <ProductTitle>
                        <span>{product.short_description}</span>
                      </ProductTitle>
                      <ProductCategory>
                        {product.product && product.product.category ? (
                          <span>{product.product.category.long_description}</span>
                        ) : (
                          <span />
                        )}
                      </ProductCategory>
                    </ContainerDetal>
                  </section>
                  {
                    (product.is_available === 0) && (
                      <AlertMessageContainer>
                        <span>Produto indisponível na loja selecionada</span>
                      </AlertMessageContainer>
                    )
                  }
                  <ContainerActions>
                    { (product.is_available === undefined || product.is_available === 1) && (
                      <ButtonAdd
                      onClick={() => {
                        const isKg = product.un === 'Kg';
                        const qtd = isKg ? (product.quantity_increment || 0.1).toFixed(3)
                        : (product?.quantity_increment || 1).toString();

                        handleCheckoutActions(
                          checkoutActionTypes.ADD_PLU_CHECKOUT,
                          product.product_id ? product.product_id : '',
                          qtd
                        )
                      } 
                      }>
                      <span>{t('main.favorites.add_to_cart')}</span>
                      <MdClose color="#FFF" />
                    </ButtonAdd>
                    )}
                    <ButtonRemove onClick={() => handleFavorite(product)}>
                      <span>{t('main.favorites.delete_from_cart')}</span>
                      <MdClose color="#FFF" />
                    </ButtonRemove>
                  </ContainerActions>
                </ProductRow>
              )})
            }
          </ProductsList>
        </ContainerMyFavorite>
      </Container>
    </Root>
  );
}

export default Favorite;
